import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'webapp-compat-give-get-footer',
  template: ` <app-give-get-footer></app-give-get-footer> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompatGiveGetFooterComponent {}
